// extracted by mini-css-extract-plugin
module.exports = {"button":"ip"};